// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-groups-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

.groups-header {
    margin-bottom: 1.5rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

.groups-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1100px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

.groups-control-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    margin-bottom: 2.5rem;
    background: white;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.groups-tabs {
    display: flex;
    gap: 0.5rem;
}

.tab-btn {
    padding: 0.85rem 1.5rem;
    border: none;
    background: transparent;
    color: #64748b;
    font-size: 1.05rem;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
}

.tab-btn:hover:not(.active) {
    background: #f1f5f9;
    color: #334155;
}

.tab-btn.active {
    background: #1e293b;
    color: white;
}

.admin-search-form {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
    max-width: 450px;
}

.admin-search-input-wrapper {
    display: flex;
    align-items: center;
    flex: 1 1;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 0.75rem;
}

.admin-search-input-wrapper:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.admin-search-icon {
    color: #94a3b8;
    flex-shrink: 0;
}

.admin-search-input {
    flex: 1 1;
    border: none;
    background: transparent;
    padding: 0.75rem 0.5rem;
    font-size: 1rem;
    color: #1e293b;
    outline: none;
    min-width: 0;
}

.admin-search-submit-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
}

.section-header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
}

.elder-section-title {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
    margin: 0;
}

.total-count-badge {
    background: #f1f5f9;
    color: #475569;
    padding: 0.4rem 1rem;
    border-radius: 99px;
    font-weight: 700;
    border: 1px solid #e2e8f0;
}

.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.elder-list-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
}

.clickable-card {
    cursor: pointer;
    transition: all 0.2s;
}

.clickable-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
    border-color: #bfdbfe;
}

.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
    min-width: 0;
}

.icon-wrapper {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-slate {
    background: #f1f5f9;
    color: #475569;
}

.icon-navy {
    background: #e0e7ff;
    color: #3730a3;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1;
    min-width: 0;
}

.title-with-status {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.elder-card-title {
    margin: 0;
    font-size: 1.25rem;
    color: #1e293b;
    font-weight: 700;
    word-break: break-word;
}

.status-badge {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-weight: 700;
    text-transform: uppercase;
}

.badge-success {
    background: #dcfce7;
    color: #15803d;
    border: 1px solid #bbf7d0;
}

.badge-warning {
    background: #fef3c7;
    color: #b45309;
    border: 1px solid #fde68a;
}

.badge-slate {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

.person-details-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.detail-text {
    font-size: 1.05rem;
    color: #64748b;
    font-weight: 500;
}

.stat-divider {
    color: #cbd5e1;
    font-size: 1.2rem;
}

.view-details-btn {
    background: transparent;
    border: none;
    color: #64748b;
    font-size: 1.05rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
}

.clickable-card:hover .view-details-btn {
    color: #2563eb;
}

/* Buttons */
.elder-btn-primary {
    background: #2563eb;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.elder-btn-success-solid {
    background: #10b981;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.elder-btn-success-outline {
    background: white;
    color: #10b981;
    border: 2px solid #bbf7d0;
    padding: 0.4rem 1rem;
    border-radius: 8px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.elder-btn-secondary {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
    padding: 0.75rem;
    border-radius: 12px;
    font-weight: 700;
    cursor: pointer;
}

.full-width {
    width: 100%;
}

.mt-1 {
    margin-top: 1rem;
}

/* Create Form */
.center-form {
    max-width: 700px;
}

.create-group-card {
    background: white;
    border-radius: 20px;
    padding: 2.5rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}

.create-header {
    text-align: center;
    margin-bottom: 2.5rem;
}

.create-header h2 {
    margin: 1rem 0 0.5rem 0;
    font-size: 1.8rem;
    color: #1e293b;
}

.create-header p {
    color: #64748b;
    margin: 0;
}

.create-header .icon-wrapper {
    margin: 0 auto;
    height: 70px;
    width: 70px;
    border-radius: 20px;
}

.form-group {
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-group label {
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.form-group input {
    padding: 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 1.1rem;
    outline: none;
    transition: border-color 0.2s;
}

.form-group input:focus {
    border-color: #3b82f6;
}

.form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
}

.submit-btn {
    width: 100%;
    justify-content: center;
    padding: 1.25rem;
    font-size: 1.2rem;
    margin-top: 1rem;
}

.error-alert {
    background: #fef2f2;
    color: #b91c1c;
    padding: 1rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    border-left: 4px solid #ef4444;
}

/* Group Details Stats */
.group-stats-overview {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
}

.g-stat-box {
    background: white;
    padding: 1.5rem;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.g-stat-box p {
    margin: 0 0 0.5rem 0;
    color: #64748b;
    font-size: 0.95rem;
    font-weight: 600;
}

.g-stat-box h4 {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

.bg-slate-50 {
    background: #f8fafc;
}

.text-blue {
    color: #2563eb;
}

/* Modals */
.elder-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
}

.elder-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2rem;
    width: 100%;
    animation: scaleIn 0.2s ease-out;
}

.add-member-modal {
    max-width: 500px;
}

.modal-search {
    max-width: 100%;
    margin-top: 1.5rem;
}

.modal-results-area {
    max-height: 300px;
    overflow-y: auto;
    margin: 1.5rem 0;
    padding-right: 0.5rem;
}

.search-result-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 12px;
    margin-bottom: 0.5rem;
    border: 1px solid #e2e8f0;
}

.res-info {
    display: flex;
    flex-direction: column;
}

.res-info strong {
    color: #1e293b;
}

.res-info span {
    color: #64748b;
    font-size: 0.9rem;
}

@keyframes scaleIn {
    from {
        transform: scale(0.95);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

/* Mobile */
@media (max-width: 900px) {
    .groups-control-panel {
        flex-direction: column;
        align-items: stretch;
        gap: 1.25rem;
    }

    .admin-search-form {
        max-width: 100%;
        width: 100%;
    }

    .group-stats-overview {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .groups-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .groups-tabs {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0.5rem;
        width: 100%;
    }

    .tab-btn {
        width: 100%;
        justify-content: center;
        padding: 0.85rem 0.5rem;
        /* Slightly less padding to fit side-by-side */
        border: 1px solid #e2e8f0;
        margin-bottom: 0;
        /* Removed margin, using grid gap instead */
        font-size: 0.95rem;
        /* Slightly smaller text to prevent wrapping */
    }

    .form-row {
        grid-template-columns: 1fr;
        gap: 0;
    }

    .elder-list-card {
        flex-direction: column;
        align-items: stretch;
    }

    .list-card-right {
        border-top: 1px solid #f1f5f9;
        padding-top: 1.25rem;
    }

    .view-details-btn {
        width: 100%;
        justify-content: space-between;
    }

    .group-stats-overview {
        grid-template-columns: 1fr;
    }
}

/* New specific styles for the Group Details Page updates */
.flex-align {
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.bg-red-light {
    background: #fef2f2;
}

.bg-green-light {
    background: #f0fdf4;
}

.border-red {
    border: 1px solid #fecaca;
}

.border-green {
    border: 1px solid #bbf7d0;
}

.text-red {
    color: #dc2626;
}

.text-green {
    color: #059669;
}

.mt-2 {
    margin-top: 0.5rem;
}

.current-due-badge {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.9rem;
    font-weight: 700;
    padding: 0.3rem 0.75rem;
    border-radius: 8px;
}

.due-pay {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fca5a5;
}

.due-receive {
    background: #dcfce7;
    color: #15803d;
    border: 1px solid #86efac;
}

.due-clear {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
}

/* === CREATE GROUP CONFIRMATION === */
.group-confirm-details {
    background: #f8fafc;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    padding: 1rem;
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.confirm-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.05rem;
    color: #475569;
}

.confirm-row strong {
    color: #1e293b;
    font-weight: 700;
}

.highlight-row {
    border-top: 1px solid #e2e8f0;
    padding-top: 0.75rem;
    margin-top: 0.25rem;
    color: #1e293b;
    font-weight: 600;
}

.highlight-row strong {
    color: #2563eb;
    font-size: 1.15rem;
}

/* === ENHANCED SEARCH RESULTS MODAL === */
.search-results-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.search-result-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: white;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
    transition: border-color 0.2s;
}

.search-result-row:hover {
    border-color: #cbd5e1;
}

.res-left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.res-icon {
    height: 44px;
    width: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f5f9;
    color: #475569;
    flex-shrink: 0;
}

.res-info {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
}

.res-info strong {
    color: #1e293b;
    font-size: 1.05rem;
}

.res-info span {
    color: #64748b;
    font-size: 0.9rem;
}

.empty-search-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    padding: 2rem 0;
    color: #94a3b8;
    text-align: center;
}

.empty-search-state p {
    margin: 0;
    font-weight: 500;
}

/* =========================================
   === DESTRUCTIVE / DANGER BUTTONS ===
   ========================================= */

.elder-btn-danger-solid {
    background: #ef4444;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: background 0.2s;
}

.elder-btn-danger-solid:hover:not(:disabled) {
    background: #dc2626;
}

.elder-btn-danger-outline {
    background: white;
    color: #ef4444;
    border: 2px solid #fecaca;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition: all 0.2s;
}

.elder-btn-danger-outline:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #ef4444;
}

.icon-btn-danger {
    background: #fef2f2;
    color: #ef4444;
    border: 1px solid #fecaca;
    width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.icon-btn-danger:hover {
    background: #fee2e2;
    border-color: #ef4444;
}

/* =========================================
   === CUSTOM DIALOG MODALS ===
   ========================================= */

.confirm-dialog-card {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.confirm-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.confirm-dialog-card h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 800;
}

.confirm-dialog-card p {
    margin: 0;
    color: #64748b;
    line-height: 1.5;
    font-size: 1.05rem;
}

.modal-actions {
    display: flex;
    gap: 1rem;
}

.modal-actions button {
    flex: 1 1;
}

.btn-primary-fill {
    background: #2563eb !important;
    color: white !important;
}

.btn-primary-fill:hover:not(:disabled) {
    background: #1d4ed8 !important;
}

.btn-danger-fill {
    background: #ef4444 !important;
    color: white !important;
}

.btn-danger-fill:hover:not(:disabled) {
    background: #dc2626 !important;
}

.btn-success-fill {
    background: #10b981 !important;
    color: white !important;
}

.btn-success-fill:hover:not(:disabled) {
    background: #059669 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Groups.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;IACzC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,WAAW;AACX;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,uBAAuB;QACvB,8CAA8C;QAC9C,yBAAyB;QACzB,gBAAgB;QAChB,2CAA2C;QAC3C,kBAAkB;QAClB,8CAA8C;IAClD;;IAEA;QACI,0BAA0B;QAC1B,MAAM;IACV;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA,sCAAsC;AACtC;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;;8CAE8C;;AAE9C;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;;8CAE8C;;AAE9C;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".admin-groups-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n.groups-header {\n    margin-bottom: 1.5rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.groups-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1100px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.groups-control-panel {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 2rem;\n    margin-bottom: 2.5rem;\n    background: white;\n    padding: 1rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.groups-tabs {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.tab-btn {\n    padding: 0.85rem 1.5rem;\n    border: none;\n    background: transparent;\n    color: #64748b;\n    font-size: 1.05rem;\n    font-weight: 600;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.tab-btn:hover:not(.active) {\n    background: #f1f5f9;\n    color: #334155;\n}\n\n.tab-btn.active {\n    background: #1e293b;\n    color: white;\n}\n\n.admin-search-form {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    max-width: 450px;\n}\n\n.admin-search-input-wrapper {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    background: white;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    padding: 0 0.75rem;\n}\n\n.admin-search-input-wrapper:focus-within {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.admin-search-icon {\n    color: #94a3b8;\n    flex-shrink: 0;\n}\n\n.admin-search-input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    padding: 0.75rem 0.5rem;\n    font-size: 1rem;\n    color: #1e293b;\n    outline: none;\n    min-width: 0;\n}\n\n.admin-search-submit-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.section-header-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.25rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin: 0;\n}\n\n.total-count-badge {\n    background: #f1f5f9;\n    color: #475569;\n    padding: 0.4rem 1rem;\n    border-radius: 99px;\n    font-weight: 700;\n    border: 1px solid #e2e8f0;\n}\n\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.elder-list-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n.clickable-card {\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.clickable-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n    border-color: #bfdbfe;\n}\n\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.icon-wrapper {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.icon-slate {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.icon-navy {\n    background: #e0e7ff;\n    color: #3730a3;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.title-with-status {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n}\n\n.elder-card-title {\n    margin: 0;\n    font-size: 1.25rem;\n    color: #1e293b;\n    font-weight: 700;\n    word-break: break-word;\n}\n\n.status-badge {\n    font-size: 0.75rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.badge-success {\n    background: #dcfce7;\n    color: #15803d;\n    border: 1px solid #bbf7d0;\n}\n\n.badge-warning {\n    background: #fef3c7;\n    color: #b45309;\n    border: 1px solid #fde68a;\n}\n\n.badge-slate {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n}\n\n.person-details-inline {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.detail-text {\n    font-size: 1.05rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.stat-divider {\n    color: #cbd5e1;\n    font-size: 1.2rem;\n}\n\n.view-details-btn {\n    background: transparent;\n    border: none;\n    color: #64748b;\n    font-size: 1.05rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n}\n\n.clickable-card:hover .view-details-btn {\n    color: #2563eb;\n}\n\n/* Buttons */\n.elder-btn-primary {\n    background: #2563eb;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.elder-btn-success-solid {\n    background: #10b981;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.elder-btn-success-outline {\n    background: white;\n    color: #10b981;\n    border: 2px solid #bbf7d0;\n    padding: 0.4rem 1rem;\n    border-radius: 8px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n.elder-btn-secondary {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n    padding: 0.75rem;\n    border-radius: 12px;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.full-width {\n    width: 100%;\n}\n\n.mt-1 {\n    margin-top: 1rem;\n}\n\n/* Create Form */\n.center-form {\n    max-width: 700px;\n}\n\n.create-group-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2.5rem;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n}\n\n.create-header {\n    text-align: center;\n    margin-bottom: 2.5rem;\n}\n\n.create-header h2 {\n    margin: 1rem 0 0.5rem 0;\n    font-size: 1.8rem;\n    color: #1e293b;\n}\n\n.create-header p {\n    color: #64748b;\n    margin: 0;\n}\n\n.create-header .icon-wrapper {\n    margin: 0 auto;\n    height: 70px;\n    width: 70px;\n    border-radius: 20px;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.form-group label {\n    font-weight: 600;\n    color: #334155;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.form-group input {\n    padding: 1rem;\n    border: 2px solid #e2e8f0;\n    border-radius: 10px;\n    font-size: 1.1rem;\n    outline: none;\n    transition: border-color 0.2s;\n}\n\n.form-group input:focus {\n    border-color: #3b82f6;\n}\n\n.form-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.5rem;\n}\n\n.submit-btn {\n    width: 100%;\n    justify-content: center;\n    padding: 1.25rem;\n    font-size: 1.2rem;\n    margin-top: 1rem;\n}\n\n.error-alert {\n    background: #fef2f2;\n    color: #b91c1c;\n    padding: 1rem;\n    border-radius: 8px;\n    margin-bottom: 1.5rem;\n    border-left: 4px solid #ef4444;\n}\n\n/* Group Details Stats */\n.group-stats-overview {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 1rem;\n}\n\n.g-stat-box {\n    background: white;\n    padding: 1.5rem;\n    border-radius: 16px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.g-stat-box p {\n    margin: 0 0 0.5rem 0;\n    color: #64748b;\n    font-size: 0.95rem;\n    font-weight: 600;\n}\n\n.g-stat-box h4 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.bg-slate-50 {\n    background: #f8fafc;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n/* Modals */\n.elder-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n}\n\n.elder-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2rem;\n    width: 100%;\n    animation: scaleIn 0.2s ease-out;\n}\n\n.add-member-modal {\n    max-width: 500px;\n}\n\n.modal-search {\n    max-width: 100%;\n    margin-top: 1.5rem;\n}\n\n.modal-results-area {\n    max-height: 300px;\n    overflow-y: auto;\n    margin: 1.5rem 0;\n    padding-right: 0.5rem;\n}\n\n.search-result-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    background: #f8fafc;\n    border-radius: 12px;\n    margin-bottom: 0.5rem;\n    border: 1px solid #e2e8f0;\n}\n\n.res-info {\n    display: flex;\n    flex-direction: column;\n}\n\n.res-info strong {\n    color: #1e293b;\n}\n\n.res-info span {\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* Mobile */\n@media (max-width: 900px) {\n    .groups-control-panel {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1.25rem;\n    }\n\n    .admin-search-form {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .group-stats-overview {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .groups-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .groups-tabs {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 0.5rem;\n        width: 100%;\n    }\n\n    .tab-btn {\n        width: 100%;\n        justify-content: center;\n        padding: 0.85rem 0.5rem;\n        /* Slightly less padding to fit side-by-side */\n        border: 1px solid #e2e8f0;\n        margin-bottom: 0;\n        /* Removed margin, using grid gap instead */\n        font-size: 0.95rem;\n        /* Slightly smaller text to prevent wrapping */\n    }\n\n    .form-row {\n        grid-template-columns: 1fr;\n        gap: 0;\n    }\n\n    .elder-list-card {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .list-card-right {\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1.25rem;\n    }\n\n    .view-details-btn {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .group-stats-overview {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* New specific styles for the Group Details Page updates */\n.flex-align {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n}\n\n.bg-red-light {\n    background: #fef2f2;\n}\n\n.bg-green-light {\n    background: #f0fdf4;\n}\n\n.border-red {\n    border: 1px solid #fecaca;\n}\n\n.border-green {\n    border: 1px solid #bbf7d0;\n}\n\n.text-red {\n    color: #dc2626;\n}\n\n.text-green {\n    color: #059669;\n}\n\n.mt-2 {\n    margin-top: 0.5rem;\n}\n\n.current-due-badge {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.9rem;\n    font-weight: 700;\n    padding: 0.3rem 0.75rem;\n    border-radius: 8px;\n}\n\n.due-pay {\n    background: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n}\n\n.due-receive {\n    background: #dcfce7;\n    color: #15803d;\n    border: 1px solid #86efac;\n}\n\n.due-clear {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n}\n\n/* === CREATE GROUP CONFIRMATION === */\n.group-confirm-details {\n    background: #f8fafc;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.confirm-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 1.05rem;\n    color: #475569;\n}\n\n.confirm-row strong {\n    color: #1e293b;\n    font-weight: 700;\n}\n\n.highlight-row {\n    border-top: 1px solid #e2e8f0;\n    padding-top: 0.75rem;\n    margin-top: 0.25rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.highlight-row strong {\n    color: #2563eb;\n    font-size: 1.15rem;\n}\n\n/* === ENHANCED SEARCH RESULTS MODAL === */\n.search-results-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.search-result-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    background: white;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n    transition: border-color 0.2s;\n}\n\n.search-result-row:hover {\n    border-color: #cbd5e1;\n}\n\n.res-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.res-icon {\n    height: 44px;\n    width: 44px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f1f5f9;\n    color: #475569;\n    flex-shrink: 0;\n}\n\n.res-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n}\n\n.res-info strong {\n    color: #1e293b;\n    font-size: 1.05rem;\n}\n\n.res-info span {\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n.empty-search-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    padding: 2rem 0;\n    color: #94a3b8;\n    text-align: center;\n}\n\n.empty-search-state p {\n    margin: 0;\n    font-weight: 500;\n}\n\n/* =========================================\n   === DESTRUCTIVE / DANGER BUTTONS ===\n   ========================================= */\n\n.elder-btn-danger-solid {\n    background: #ef4444;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    transition: background 0.2s;\n}\n\n.elder-btn-danger-solid:hover:not(:disabled) {\n    background: #dc2626;\n}\n\n.elder-btn-danger-outline {\n    background: white;\n    color: #ef4444;\n    border: 2px solid #fecaca;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-weight: 700;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    transition: all 0.2s;\n}\n\n.elder-btn-danger-outline:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: #ef4444;\n}\n\n.icon-btn-danger {\n    background: #fef2f2;\n    color: #ef4444;\n    border: 1px solid #fecaca;\n    width: 38px;\n    height: 38px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.icon-btn-danger:hover {\n    background: #fee2e2;\n    border-color: #ef4444;\n}\n\n/* =========================================\n   === CUSTOM DIALOG MODALS ===\n   ========================================= */\n\n.confirm-dialog-card {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.confirm-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.confirm-dialog-card h3 {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.confirm-dialog-card p {\n    margin: 0;\n    color: #64748b;\n    line-height: 1.5;\n    font-size: 1.05rem;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.modal-actions button {\n    flex: 1;\n}\n\n.btn-primary-fill {\n    background: #2563eb !important;\n    color: white !important;\n}\n\n.btn-primary-fill:hover:not(:disabled) {\n    background: #1d4ed8 !important;\n}\n\n.btn-danger-fill {\n    background: #ef4444 !important;\n    color: white !important;\n}\n\n.btn-danger-fill:hover:not(:disabled) {\n    background: #dc2626 !important;\n}\n\n.btn-success-fill {\n    background: #10b981 !important;\n    color: white !important;\n}\n\n.btn-success-fill:hover:not(:disabled) {\n    background: #059669 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
